import { Checkbox, CustomButton, FormInput } from '@ui-kit'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { WelcomeCallFormType } from '../../types/patient-adherence.types'

const WelcomeCall = ({
  setVisibleState,
  setSelectedTabIndex,
}: {
  setVisibleState: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedTabIndex: React.Dispatch<React.SetStateAction<number>>
}) => {
  const welcomeCallForm: WelcomeCallFormType = {
    preffered_language: null,
    people_in_household: null,
    alcohol_consumption: null,
    weekly_drive: null,
    phone_input: null,
    text_input: null,
    email_input: null,
  }

  const {
    register,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues: welcomeCallForm })

  const [handleCheckbox, setHandleCheckbox] = useState<string[]>([
    'phone_input',
  ])

  useEffect(() => {
    setValue('preffered_language', 'English')
    setValue('people_in_household', '5')
    setValue('alcohol_consumption', '4')
    setValue('weekly_drive', '7')
    setValue('phone_input', '123 456 7890')
  }, [])

  const handleEnableField = (key: string) => {
    const inputKey = `${key}_input`
    setHandleCheckbox((prev) =>
      prev.includes(inputKey)
        ? prev.filter((item) => item !== inputKey)
        : [...prev, inputKey]
    )
  }

  const handleSave = () => {
    setSelectedTabIndex(3)
    setVisibleState(false)
  }

  return (
    <div className="font-primary flex flex-col gap-4 border border-[#E3E3E3] rounded-lg p-4 min-h-[40vh]">
      <div className="top flex justify-between items-center">
        <div className="flex flex-col">
          <span className="text-base font-semibold leading-6">
            Welcome Call
          </span>
          <span className="text-xs leading-6">
            The initial welcome call introduces the program to the patient,
            explains services, sets expectations, and captures additional data
            elements to refine risk score and risk factors.
          </span>
        </div>
        <div className="flex gap-2">
          <CustomButton color="primary" onClick={() => setVisibleState(false)}>
            <span>Cancel</span>
          </CustomButton>
          <CustomButton
            color="primary"
            isFilled={true}
            onClick={handleSave}
            widthClass="w-fit"
          >
            <div className="flex gap-2">
              <span>View Updated Adherence Plan</span>
              <span>&gt;</span>
            </div>
          </CustomButton>
        </div>
      </div>
      {/* Topbar ends here */}
      <div className="content flex gap-12">
        <div className="flex-[2] flex gap-4 p-2 flex-col">
          <FormInput
            name="preffered_language"
            label="What is your Preferred Language"
            register={register}
            errors={errors}
          />
          <FormInput
            name="people_in_household"
            label="How many people are in your household?"
            register={register}
            errors={errors}
          />
          <FormInput
            name="alcohol_consumption"
            label="How many alcoholic drinks do you consume per week?"
            register={register}
            errors={errors}
          />
          <FormInput
            name="weekly_drive"
            label="How many times per week do you drive your car?"
            register={register}
            errors={errors}
          />
        </div>
        <div className="flex-1 flex-col">
          <div className="my-2">
            <span className="font-medium text-base">
              What is the best way to contact you?
            </span>
          </div>
          <div className="flex flex-col gap-3 px-4">
            <div className="flex justify-between">
              <Checkbox
                label={'Phone'}
                name={'phone'}
                onClick={() => handleEnableField('phone')}
                checked={handleCheckbox.includes('phone_input')}
              />
              <div className="w-80">
                <FormInput
                  name={'phone_input'}
                  label=""
                  placeholder="Enter Phone Number"
                  disabled={!handleCheckbox.includes('phone_input')}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <Checkbox
                label={'Text'}
                name={'text'}
                onClick={() => handleEnableField('text')}
              />
              <div className="w-80">
                <FormInput
                  name={'text_input'}
                  label=""
                  placeholder="Enter Text"
                  disabled={!handleCheckbox.includes('text_input')}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <Checkbox
                label={'Email'}
                name={'email'}
                onClick={() => handleEnableField('email')}
              />
              <div className="w-80">
                <FormInput
                  name={'email_input'}
                  label=""
                  placeholder="Enter Email"
                  disabled={!handleCheckbox.includes('email_input')}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomeCall
